import { useState } from 'react';
import {
  Container,
  Header,
  Box,
  Button,
  Form,
  FormField,
  Input,
  SpaceBetween,
  Link,
  Alert,
  Grid,
} from '@cloudscape-design/components';
import { ViewLayout } from '../../components/ViewLayout';

export default function PrivacyPage() {
  return (
    <ViewLayout
      breadcrumbs={[{ text: 'Privacy', href: '' }]}
      navigationHide
      header={
        <Header description="Privacy Policy for AI Escape and Real Time Feedback" variant="h1">
          Privacy Policy
        </Header>
      }
    >
      <Grid
        gridDefinition={[
          {
            colspan: {
              default: 12,
              l: 8,
              s: 6,
            },
          },
        ]}
      >
        <Container header={<Header variant="h2">Privacy Policy</Header>}>
          <SpaceBetween size="l">
            <Box variant="p">
              <strong>Last Updated:</strong> 2025-01-01
            </Box>

            <Box variant="p">
              Welcome to the Real Time Feedback AI Analytics platform, built by AI Escape (“we”,
              “us”, or “our”). We value your privacy and are committed to protecting your personal
              information. This Privacy Policy describes how we collect, use, and share your
              information when you visit our website (ai.realtimefeedback.com) and use our services.
            </Box>

            <Box variant="p">
              <strong>1. Information We Collect</strong>
              <br />
              We may collect information about you in various ways, including:
              <ul>
                <li>
                  <strong>Personal Information:</strong> Such as your name, email address, and phone
                  number when you sign up, complete a form, or contact us.
                </li>
                <li>
                  <strong>Usage Data:</strong> Information about your interaction with our website,
                  including your IP address, browser type, pages viewed, and referring URLs.
                </li>
                <li>
                  <strong>SMS Data:</strong> If you opt in to receive SMS messages, we may collect
                  your mobile phone number along with records of your consent and message
                  interactions.
                </li>
              </ul>
            </Box>

            <Box variant="p">
              <strong>2. How We Use Your Information</strong>
              <br />
              We use the collected information for various purposes, including to:
              <ul>
                <li>Provide, maintain, and improve our services.</li>
                <li>
                  Communicate with you about updates, promotions, or important service information.
                </li>
                <li>Personalize your experience on our website.</li>
                <li>Monitor and analyze usage trends to help improve our service.</li>
              </ul>
            </Box>

            <Box variant="p">
              <strong>3. How We Share Your Information</strong>
              <br />
              We do not sell your personal information. However, we may share your data with:
              <ul>
                <li>
                  <strong>Third-Party Service Providers:</strong> Trusted vendors (such as SMS
                  providers like Twilio) who assist us in delivering our services, provided they
                  adhere to data protection standards.
                </li>
                <li>
                  <strong>Legal Requirements:</strong> If required by law or to protect our rights,
                  we may disclose your information.
                </li>
              </ul>
            </Box>

            <Box variant="p">
              <strong>4. Data Security</strong>
              <br />
              We take reasonable measures to help protect your personal information from
              unauthorized access, disclosure, alteration, or destruction. However, no internet or
              email transmission is ever fully secure or error free.
            </Box>

            <Box variant="p">
              <strong>5. Your Choices</strong>
              <br />
              You have choices regarding the collection and use of your personal information:
              <ul>
                <li>
                  <strong>Opting Out:</strong> You may opt out of receiving SMS messages at any time
                  by replying with “STOP” or contacting us.
                </li>
                <li>
                  <strong>Updating Your Information:</strong> You can update or request deletion of
                  your personal information by contacting us.
                </li>
              </ul>
            </Box>

            <Box variant="p">
              <strong>6. Changes to This Privacy Policy</strong>
              <br />
              We may update this Privacy Policy periodically. We will post any changes on this page
              and, if the changes are significant, we will provide a more prominent notice. Your
              continued use of our services after any changes will indicate your acceptance of the
              updated policy.
            </Box>

            <Box variant="p">
              <strong>7. Contact Us</strong>
              <br />
              If you have any questions or concerns about this Privacy Policy, please contact us at{' '}
              <Link href="mailto:support@aiescape.io">support@aiescape.io</Link>.
            </Box>
          </SpaceBetween>
        </Container>
      </Grid>
    </ViewLayout>
  );
}
